var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconModuleEMagazines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-module-e-magazines",
    transform: "translate(-31.973 0.027)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5839",
    "data-name": "Rectangle 5839",
    width: 92,
    height: 92,
    transform: "translate(31.973 -0.027)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "magazine",
    transform: "translate(54.987 16.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40886",
    "data-name": "Path 40886",
    d: "M63.1,14H23.857c-3.38.376-5.257,2.253-5.257,4.882V67.513a5.413,5.413,0,0,0,5.445,5.257H63.288c.376,0,.751-.188.751-.563a.686.686,0,0,0-.376-.939,4.9,4.9,0,0,1-1.878-3.755,3.873,3.873,0,0,1,1.878-3.192h0v-.188h0V14.939C64.039,14.376,63.664,14,63.1,14ZM24.8,15.69H62.349V62.444H24.8V15.69Zm-.939,55.2a3.565,3.565,0,0,1-3.568-3.568V18.882a3.028,3.028,0,0,1,2.816-2.816v47.5a.887.887,0,0,0,.939.939H61.223a5.674,5.674,0,0,0-.939,3,6.182,6.182,0,0,0,1.127,3.568H23.857Z",
    transform: "translate(-18.6 -14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40887",
    "data-name": "Path 40887",
    d: "M26.139,34.321H49.422a.887.887,0,0,0,.939-.939V20.239a.887.887,0,0,0-.939-.939H26.139a.887.887,0,0,0-.939.939V33.382A1.006,1.006,0,0,0,26.139,34.321Zm.939-13.144H48.483V32.444H27.078Z",
    transform: "translate(-12.807 -9.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40888",
    "data-name": "Path 40888",
    d: "M49.422,30.6H26.139a.939.939,0,0,0,0,1.878H49.422a.887.887,0,0,0,.939-.939C50.173,30.976,49.8,30.6,49.422,30.6Z",
    transform: "translate(-12.807 0.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40889",
    "data-name": "Path 40889",
    d: "M49.422,34.5H26.139a.939.939,0,1,0,0,1.878H49.422a.887.887,0,0,0,.939-.939C50.173,34.876,49.8,34.5,49.422,34.5Z",
    transform: "translate(-12.807 3.992)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleEMagazines);
export default __webpack_public_path__ + "static/media/icon-module-e-magazines.ca1533b9.svg";
export { ForwardRef as ReactComponent };